import { useMemo } from 'react'
import { orderBy } from 'lodash'
import { useAppContext } from '../../../../redux/slices/appContext'
import {
  useWealthMissionValueDefaults as useMissionValueDefaults,
  useWealthMissionValues as useMissionValues
} from '../../../../api/groups'

const normalizeMissionValues = (value) => {
  if (Array.isArray(value)) return value
  if (Array.isArray(value?.items)) return value.items
  if (Array.isArray(value?.wealthMissionValues)) return value.wealthMissionValues
  if (Array.isArray(value?.wealthMissionValueDefaults)) return value.wealthMissionValueDefaults
  return []
}

const useWealthMissionValueOptions = () => {
  const { clientId } = useAppContext()

  const { query, queryOptions } = useMemo(
    () => ({
      query: { levelType: 'clients', levelIds: [clientId] },
      queryOptions: {}
    }),
    [clientId]
  )

  const {
    data: wealthMissionValueDefaultsData,
    isLoading: isLoadingWealthMissionValueDefaults
  } = useMissionValueDefaults()

  const {
    data: wealthMissionValuesData,
    isLoading,
    refetch
  } = useMissionValues(query, queryOptions)

  const wealthMissionValueDefaults = useMemo(
    () => normalizeMissionValues(wealthMissionValueDefaultsData),
    [wealthMissionValueDefaultsData]
  )

  const wealthMissionValues = useMemo(
    () => normalizeMissionValues(wealthMissionValuesData),
    [wealthMissionValuesData]
  )

  const missionValues = useMemo(() => {
    const wealthValueDefaultIds = [
      ...new Set(
        wealthMissionValues.map(
          ({ wealthMissionValueDefaultId }) => wealthMissionValueDefaultId
        )
      )
    ]
    const wealthValueDefaults = wealthMissionValueDefaults.filter(
      ({ wealthMissionValueDefaultId }) =>
        !wealthValueDefaultIds.includes(wealthMissionValueDefaultId)
    )

    return orderBy([...wealthMissionValues, ...wealthValueDefaults], ['title'], ['asc'])
  }, [wealthMissionValueDefaults, wealthMissionValues])

  return {
    missionValues,
    wealthMissionValues,
    wealthMissionValueDefaults,
    refetchWealthMissionValues: refetch,
    isLoading: isLoading || isLoadingWealthMissionValueDefaults
  }
}

export default useWealthMissionValueOptions
